export const SERVICE_GROUPS = [
  {
    label: "Immigration Services",
    options: [
      ["family-petition-i130", "Family Petition (I-130)"],
      ["adjustment-of-status-green-card", "Adjustment of Status / Green Card"],
      ["citizenship-naturalization-n400", "Citizenship & Naturalization (N-400)"],
      ["removal-of-conditions-i751", "Removal of Conditions (I-751)"],
      ["fiance-visa-k1", "Fiancé(e) Visa (K-1)"],
      ["spouse-marriage-visa", "Spouse / Marriage Visa"],
      ["parent-immigration", "Parent Immigration"],
      ["child-immigration", "Child Immigration"],
      ["consular-processing", "Consular Processing"],
      ["nvc-case-assistance", "NVC Case Assistance"],
      ["us-embassy-consulate-case-assistance", "U.S. Embassy / Consulate Case Assistance"],
      ["visa-application-assistance", "Visa Application Assistance"],
      ["work-authorization-i765", "Work Authorization (I-765)"],
      ["advance-parole-travel-document", "Advance Parole / Travel Document"],
      ["green-card-renewal-replacement-i90", "Green Card Renewal / Replacement (I-90)"],
      ["affidavit-of-support-i864", "Affidavit of Support (I-864)"],
      ["joint-sponsor-assistance", "Joint Sponsor Assistance"],
      ["uscis-rfe-response", "USCIS Request for Evidence (RFE) Response"],
      ["uscis-notice-case-review", "USCIS Notice / Case Review"],
      ["foia-request", "FOIA Request"],
      ["immigration-records-request", "Immigration Records Request"],
      ["asylum-document-preparation", "Asylum Document Preparation"],
      ["immigration-affidavit-declaration-preparation", "Immigration Affidavit / Declaration Preparation"],
      ["immigration-document-review", "Immigration Document Review"],
      ["immigration-document-translation", "Immigration Document Translation"],
      ["general-immigration-consultation", "General Immigration Consultation"],
    ],
  },
  {
    label: "Translation & Notary",
    options: [
      ["certified-translation", "Certified Translation"],
      ["somali-english-translation", "Somali–English Translation"],
      ["other-document-translation", "Other Document Translation"],
      ["general-notary", "General Notary"],
      ["remote-online-notary", "Remote Online Notary"],
      ["mobile-notary", "Mobile Notary"],
      ["affidavit-declaration", "Affidavit / Declaration"],
      ["travel-consent-authorization", "Travel Consent / Authorization"],
    ],
  },
  {
    label: "Tax & Other Services",
    options: [
      ["individual-tax-preparation", "Individual Tax Preparation"],
      ["self-employed-1099-tax-preparation", "Self-Employed / 1099 Tax Preparation"],
      ["business-tax-preparation", "Business Tax Preparation"],
      ["tax-amendment", "Tax Amendment"],
      ["irs-letter-notice-assistance", "IRS Letter / Notice Assistance"],
      ["itin-application", "ITIN Application"],
      ["business-document-preparation", "Business Document Preparation"],
      ["other-not-listed", "Other / Not Listed"],
    ],
  },
];

export const SERVICE_LABEL_LOOKUP = Object.fromEntries([
  ...SERVICE_GROUPS.flatMap((group) => group.options),
  ["family-petition", "Family petition"],
  ["adjustment-status", "Adjustment of status"],
  ["citizenship", "Citizenship / naturalization"],
  ["nvc-consular", "NVC / consular processing"],
  ["translation", "Certified translation"],
  ["other", "Other immigration support"],
]);
